import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28b09d6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-col relative" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex flex-wrap justify-center items-center align-center" }
const _hoisted_5 = { class: "text-center mt-8" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "answer-wrapper w-full h-full fixed z-10 opacity-95 bg-pxblue justify-center items-center top-0 left-0 right-0 bottom-0 flex flex-col p-4"
}
const _hoisted_8 = { class: "text-justify" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" All of the products shown contain Rare Earths alloys / magnets! Our modern societies and economies depend heavily on them. Let's take a closer look at what these Rare Earth Elements are. ")
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/girl_correct.svg",
  class: "w-1/3 mx-auto mt-8",
  alt: "devices_modal_girl"
}, null, -1))
const _hoisted_12 = { class: "text-center mt-16" }
const _hoisted_13 = { class: "text-2xl text-white font-space" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Do you know why we call them \"rare\"? ")
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", {
            innerHTML: _ctx.$t('screen.guess'),
            class: "mb-8 font-space text-medium font-bold text-xl"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:translate-y-8", {selected: _ctx.selected['fridge']}])
          }, [
            _createElementVNode("img", {
              src: "img/fridge.png",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.select('fridge'))),
              class: "w-full mx-auto"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform", {selected: _ctx.selected['headphones']}])
          }, [
            _createElementVNode("img", {
              src: "img/headphones.png",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.select('headphones'))),
              class: "w-full mx-auto md:p-8"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:translate-y-8", {selected: _ctx.selected['speakers']}])
          }, [
            _createElementVNode("img", {
              src: "img/speakers.png",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.select('speakers'))),
              class: "w-full mx-auto"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:-translate-y-4", {selected: _ctx.selected['laptop']}])
          }, [
            _createElementVNode("img", {
              src: "img/laptop.png",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.select('laptop'))),
              class: "w-full mx-auto"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:translate-y-8", {selected: _ctx.selected['phone']}])
          }, [
            _createElementVNode("img", {
              src: "img/phone.png",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.select('phone'))),
              class: "w-full mx-auto"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:-translate-x-8", {selected: _ctx.selected['car']}])
          }, [
            _createElementVNode("img", {
              src: "img/car.png",
              class: "w-full mx-auto",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.select('car')))
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:-translate-y-4", {selected: _ctx.selected['washer']}])
          }, [
            _createElementVNode("img", {
              src: "img/washer.png",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.select('washer'))),
              class: "w-full mx-auto md:p-4"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:-translate-y-8", {selected: _ctx.selected['guitar']}])
          }, [
            _createElementVNode("img", {
              src: "img/guitar.png",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.select('guitar'))),
              class: "w-full mx-auto"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item transform md:-translate-y-4", {selected: _ctx.selected['turbine']}])
          }, [
            _createElementVNode("img", {
              src: "img/turbine.png",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.select('turbine'))),
              class: "max-h-72 mx-auto"
            })
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            disabled: !_ctx.anySelected,
            class: "px-8 orange-button",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkAnswers && _ctx.checkAnswers(...args)))
          }, _toDisplayString(_ctx.anySelected ? _ctx.$t('Check answers') : _ctx.$t('Click or tap on the images above')), 9, _hoisted_6)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"]),
    (_ctx.ok)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Card, {
            title: _ctx.$t('That\'s correct'),
            class: "w-card max-w-full"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_8, _hoisted_10)), [
                [_directive_t, _ctx.$t('devices.card.par1')]
              ]),
              _hoisted_11
            ]),
            _: 1
          }, 8, ["title"]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives((_openBlock(), _createElementBlock("h4", _hoisted_13, _hoisted_15)), [
              [_directive_t, 'devices.card.par2']
            ]),
            _createElementVNode("img", {
              src: "img/arrow.icon.svg",
              alt: "next page",
              class: "next-arrow2 mx-auto mt-4",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}